const PUBLIC_CV_MIME_BY_EXTENSION: Record<string, string> = {
  pdf: "application/pdf",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  webp: "image/webp",
};

export function isSupportedPublicCvBrowserFile(name: string, type: string): boolean {
  const extension = name.split(".").pop()?.toLowerCase() ?? "";
  const canonicalMimeType = PUBLIC_CV_MIME_BY_EXTENSION[extension];
  const suppliedMimeType = type.trim().toLowerCase().split(";", 1)[0];
  return Boolean(canonicalMimeType)
    && (suppliedMimeType === ""
      || suppliedMimeType === "application/octet-stream"
      || suppliedMimeType === canonicalMimeType);
}

const PUBLIC_CV_ERROR_KEYS: Record<string, string> = {
  cv_empty_file: "publicApply.cv.emptyFile",
  cv_file_too_large: "publicApply.cv.tooLarge",
  cv_invalid_extension: "publicApply.cv.invalidType",
  cv_invalid_mime: "publicApply.cv.invalidType",
  cv_invalid_signature: "publicApply.cv.invalidSignature",
  cv_unsafe_file: "publicApply.cv.unsafeFile",
};

export function publicCvErrorTranslationKey(code: unknown): string | null {
  return typeof code === "string" ? PUBLIC_CV_ERROR_KEYS[code] ?? null : null;
}
